import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';

import { AuthService } from '../../services/auth.service';
import { ClienteService } from '../../services/cliente.service';
import { UnidadeService } from '../../services/unidade.service';
import { ProfissionalService } from '../../services/profissional.service';
import { VeiculoService } from '../../services/veiculo.service';
import { CheckSocorristaService } from '../../services/check-socorrista.service';

@Component({
  selector: 'app-checklist-print',
  templateUrl: './checklist-print.component.html',
  styleUrls: ['./checklist-print.component.css']
})
export class ChecklistPrintComponent implements OnInit {

  public checklist = {
    'check_socorrista_data': '',
    'check_socorrista_turno': '',
    'check_socorrista_justificativa': '',
    'inicioPeriodo': '',
    'cliente': {
      'cliente_nome': ''
    },
    'unidade': {
      'unidade_nome': ''
    },
    'profissional': {
      'profissional_nome': ''
    },
    'veiculo': {
      'veiculo_placa': ''
    },
    'check_socorrista_quilometragem': '',
    'check_socorrista_documentacao_flag': '',
    'check_socorrista_documentacao_obs': '',
    'check_socorrista_cartao_abastecimento_flag': '',
    'check_socorrista_cartao_abastecimento_obs': '',
    'check_socorrista_iluminacao_flag': '',
    'check_socorrista_iluminacao_obs': '',
    'check_socorrista_sinais_sonoros_flag': '',
    'check_socorrista_sinais_sonoros_obs': '',
    'check_socorrista_pneus_flag': '',
    'check_socorrista_pneus_obs': '',
    'check_socorrista_fluido_freio_flag': '',
    'check_socorrista_fluido_freio_obs': '',
    'check_socorrista_oleo_motor_flag': '',
    'check_socorrista_oleo_motor_data_troca': '',
    'check_socorrista_oleo_hidraulico_flag': '',
    'check_socorrista_oleo_hidraulico_obs': '',
    'check_socorrista_unidade_limpa_flag': '',
    'check_socorrista_unidade_limpa_obs': '',
    'check_socorrista_combustivel_flag': '',
    'check_socorrista_marca_retratil_completa_flag': '',
    'check_socorrista_marca_retratil_completa_obs': '',
    'check_socorrista_prancha_longa_completa_flag': '',
    'check_socorrista_prancha_longa_completa_obs': '',
    'check_socorrista_torpedo_oxigenio_reserva_flag': '',
    'check_socorrista_torpedo_oxigenio_reserva_obs': '',
    'check_socorrista_chave_o2_flag': '',
    'check_socorrista_chave_o2_obs': '',
    'check_socorrista_inversor_flag': '',
    'check_socorrista_radio_ht_flag': '',
    'check_socorrista_celular_carregador_flag': '',
    'check_socorrista_macaco_flag': '',
    'check_socorrista_triangulo_flag': '',
    'check_socorrista_chave_roda_flag': '',
    'check_socorrista_socorro_flag': '',
    'check_socorrista_lanterna_flag': '',
    'check_socorrista_alicate_8_flag': '',
    'check_socorrista_chave_fenda_1_4_flag': '',
    'check_socorrista_chave_fenda_5_16_flag': '',
    'check_socorrista_martelo_pena_flag': '',
    'check_socorrista_jogo_chave_boca_fixa_flag': '',
    'check_socorrista_jogo_chave_estrela_flag': '',
    'check_socorrista_lima_flag': '',
    'check_socorrista_pe_de_cabra_flag': '',
    'check_socorrista_talhadeira_flag': '',
    'check_socorrista_cabo_energia_flag': '',
    'check_socorrista_ar_comprimido_flag': '',
    'check_socorrista_status': ''};

  constructor(
    private authSvc: AuthService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private location: Location,
    private router: Router,
    private clienteSvc: ClienteService,
    private unidadeSvc: UnidadeService,
    private profissionalSvc: ProfissionalService ,
    private veiculoSvc: VeiculoService,
    private checkSocorristaSvc: CheckSocorristaService) { }

  ngOnInit() {
    this.route.params.subscribe( params => {
			if (params.id) {
				this.checkSocorristaSvc.getCheckSocorrista(params.id).then((data: any) => {
          data.check_socorrista_data = moment(data.check_socorrista_data, 'YYYY-MM-DD').format('DD/MM/YYYY');
          this.checklist = data;
				});
			}
		});
  }


  formatDataSimNao(data){
    switch(data){
      case 'S':
        return 'Sim';
      case 'N':
        return 'Não';
      default:
        return ''; 
    }
  }

  formatDataCombustivel(data){
    switch(data){
      case 'CH':
        return 'Cheio';
      case '34':
        return '3/4';
      case '12':
        return '1/2';
      case '14':
        return '1/4';
      case 'ND':
        return '0';
      default:
        return '';
    }
  }

}
